(function ($) {
  'use strict';

  var $card = $('#battery-telemetry-chart-card');
  var $container = $('#battery-telemetry-chart-container-new');
  var $empty = $('#battery-telemetry-chart-empty');
  var $loading = $('#battery-telemetry-chart-loading');
  var $title = $('#battery-telemetry-chart-title');
  var $time = $('#waktu');
  var $periode = $('#periode');
  var chart = null;
  var stationType = $('#station-type2').val();
  var isFlowMeter = stationType === 'FM';

  if (!$container.length) {
    return;
  }

  var telemetryChartAjaxGuard =
    typeof createTelemetryChartLoadGuard === 'function'
      ? createTelemetryChartLoadGuard()
      : {
          start: function () {
            return {
              isCurrent: function () {
                return true;
              },
              register: function () {},
              clearIfCurrent: function () {},
            };
          },
        };

  function normalizeFilterDateFlowMeter(selectedTime, value) {
    var raw = (value || '').trim();
    var monthNameFormats = ['MMMM YYYY', 'MMM YYYY'];
    var dayNameFormats = ['D MMMM YYYY', 'DD MMMM YYYY', 'D MMM YYYY'];

    if (selectedTime === 'day') {
      if (moment(raw, 'YYYY', true).isValid()) {
        return moment(raw, 'YYYY', true).format('YYYY');
      }
      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
      }
      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM');
      }
      var dayParsed = moment(raw, dayNameFormats, 'id', true);
      if (!dayParsed.isValid()) {
        dayParsed = moment(raw, dayNameFormats, true);
      }
      if (dayParsed.isValid()) {
        return dayParsed.format('YYYY-MM');
      }
      var monthParsed = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsed.isValid()) {
        monthParsed = moment(raw, monthNameFormats, true);
      }
      if (monthParsed.isValid()) {
        return monthParsed.format('YYYY-MM');
      }
      return moment().format('YYYY');
    }

    if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
      return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
    }
    var dayParsedM = moment(raw, dayNameFormats, 'id', true);
    if (!dayParsedM.isValid()) {
      dayParsedM = moment(raw, dayNameFormats, true);
    }
    if (dayParsedM.isValid()) {
      return dayParsedM.format('YYYY-MM-DD');
    }
    if (moment(raw, 'YYYY-MM', true).isValid()) {
      return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
    }
    var monthParsedM = moment(raw, monthNameFormats, 'id', true);
    if (!monthParsedM.isValid()) {
      monthParsedM = moment(raw, monthNameFormats, true);
    }
    if (monthParsedM.isValid()) {
      return monthParsedM.format('YYYY-MM');
    }
    return moment().format('YYYY-MM-DD');
  }

  function getFilterDateFlowMeter(selectedTime) {
    var value = $periode.length ? $periode.val() : '';
    return normalizeFilterDateFlowMeter(selectedTime, value);
  }

  function hideFlowMeterBatteryUi() {
    $card.hide();
    $loading.hide();
    $empty.hide();
    $container.hide();
    if (chart) {
      chart.destroy();
      chart = null;
    }
  }

  function loadGrafikBattery() {
    if (isFlowMeter) {
      if (getSelectedTime() === 'day' || getSelectedTime() === 'month') {
        hideFlowMeterBatteryUi();
        return;
      }
      $card.show();
      if ($title.length) {
        $title.text('Grafik Baterai (per jam)');
      }
      loadBatteryChartFlowMeter();
    } else if ($time.val() === 'minute') {
      $card.show();
      loadBatteryChart();
    } else {
      $card.hide();
    }
  }

  function getSelectedTime() {
    if (!$time.length || !$time.val()) {
      return isFlowMeter ? 'hour' : 'minute';
    }
    var v = $time.val();
    if (isFlowMeter && v === 'minute') {
      return 'hour';
    }
    return v;
  }

  function getFilterDate(selectedTime) {
    var raw = ($periode.val() || '').trim();
    return raw;
  }

  function showLoading() {
    $empty.hide();
    $container.hide();
    $loading.show();
  }

  function clampCapacitySeries(data) {
    if (!Array.isArray(data)) {
      return data;
    }
    return data.map(function (point) {
      if (Array.isArray(point)) {
        var y = point[1];
        if (y == null || !Number.isFinite(Number(y))) {
          return point;
        }
        return [point[0], Math.min(100, Number(y))];
      }
      if (point && typeof point === 'object') {
        var py = point.y;
        if (py == null || !Number.isFinite(Number(py))) {
          return point;
        }
        return Object.assign({}, point, { y: Math.min(100, Number(py)) });
      }
      return point;
    });
  }

  function renderChart(voltageData, capacityData) {
    $loading.hide();
    $empty.hide();
    $container.show();

    if (chart) {
      chart.destroy();
    }

    Highcharts.setOptions({
      time: { useUTC: true },
      lang: {
        weekdays: [
          'Minggu',
          'Senin',
          'Selasa',
          'Rabu',
          'Kamis',
          'Jumat',
          'Sabtu',
        ],
        months: [
          'Januari',
          'Februari',
          'Maret',
          'April',
          'Mei',
          'Juni',
          'Juli',
          'Agustus',
          'September',
          'Oktober',
          'November',
          'Desember',
        ],
      },
    });

    chart = Highcharts.chart('battery-telemetry-chart-container-new', {
      chart: {
        type: 'column',
        zoomType: 'x',
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        floating: false,
        itemStyle: {
          fontSize: '11px',
          fontWeight: 'normal',
        },
        zIndex: 100,
      },
      navigator: {
        enabled: true,
        height: 25,
        margin: 5,
        xAxis: {
          labels: {
            style: { fontSize: '9px' },
            dateTimeLabelFormats: {
              hour: '%H:%M',
              minute: '%H:%M',
            },
          },
        },
      },
      title: { text: '' },
      xAxis: {
        type: 'datetime',
        ordinal: false,
        minRange: 3600000,
        title: { text: 'Waktu', style: { fontSize: '12px' } },
        labels: {
          rotation: -25,
          style: { fontSize: '11px', color: '#666' },
          formatter: function () {
            return Highcharts.dateFormat('%e %b %Y %H:%M', this.value);
          },
        },
      },
      yAxis: [
        {
          title: { text: 'Tegangan (V)', style: { color: '#2196F3' } },
          labels: { format: '{value} V', style: { color: '#2196F3' } },
          gridLineWidth: 0,
        },
        {
          title: { text: 'Kapasitas (%)', style: { color: '#4CAF50' } },
          labels: { format: '{value}%', style: { color: '#4CAF50' } },
          opposite: true,
          min: 0,
          max: 100,
          ceiling: 100,
          floor: 0,
          maxPadding: 0,
          minPadding: 0,
          startOnTick: true,
          endOnTick: true,
          gridLineWidth: 0,
          tickPositioner: function () {
            return [0, 25, 50, 75, 100];
          },
        },
      ],
      plotOptions: {
        line: { marker: { enabled: false }, lineWidth: 2 },
        column: {
          borderWidth: 0,
          groupPadding: 0.1,
          pointPadding: 0,
          maxPointWidth: 40,
        },
        series: {
          boostThreshold: 10000,
          turboThreshold: 0,
          cropThreshold: Infinity,
        },
      },
      series: [
        {
          name: 'Tegangan',
          type: 'line',
          yAxis: 0,
          zIndex: 10,
          data: voltageData,
          color: '#D35400',
          tooltip: {
            valueSuffix: ' V',
          },
        },
        {
          name: 'Kapasitas',
          type: 'column',
          yAxis: 1,
          zIndex: 1,
          data: clampCapacitySeries(capacityData),
          color: '#4CAF50',
          opacity: 0.6,
          tooltip: { valueSuffix: '%' },
          zones: [
            { value: 20, color: '#E53935' },
            { value: 40, color: '#FF9800' },
            { value: 60, color: '#FFC107' },
            { color: '#4CAF50' },
          ],
        },
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          var fmt =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber
              : function (v) {
                  return Highcharts.numberFormat(v, 2);
                };
          var tanggal = Highcharts.dateFormat('%A, %e %B %Y %H:%M', this.x);
          var tooltip = '<b>' + tanggal + '</b><br/>';
          this.points.forEach(function (point) {
            var value = fmt(point.y);
            tooltip +=
              '<span style="color:' +
              point.color +
              '">●</span> ' +
              point.series.name +
              ': <b>' +
              value +
              point.series.userOptions.tooltip.valueSuffix +
              '</b><br/>';
          });
          return tooltip;
        },
      },

      credits: { enabled: false },
    });
  }

  function loadBatteryChart() {
    if (typeof Highcharts === 'undefined') {
      return;
    }

    var selectedTime = getSelectedTime();
    var filterDate = getFilterDate(selectedTime);

    if (selectedTime !== 'minute') {
      $container.hide();
      $empty
        .text('Grafik baterai hanya tersedia untuk data per 5 menit.')
        .show();
      return;
    }

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    var jqXHR = $.ajax({
      url: '/Station/GetChartDataBattery',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
        stationType: stationType,
      },
    });
    g.register(jqXHR);

    jqXHR
      .done(function (response) {
        if (!g.isCurrent()) {
          return;
        }
        var res = response.data;
        if (res && res.voltageSeries && res.voltageSeries.length > 0) {
          renderChart(res.voltageSeries, res.capacitySeries);
        } else {
          $container.hide();
          $loading.hide();
          $empty.text('Data grafik baterai tidak tersedia.').show();
        }
      })
      .fail(function (_xhr, status) {
        if (status === 'abort') {
          return;
        }
        if (!g.isCurrent()) {
          return;
        }
        $container.hide();
        $loading.hide();
        $empty.text('Gagal memuat data.').show();
      })
      .always(function () {
        g.clearIfCurrent();
      });
  }

  function loadBatteryChartFlowMeter() {
    if (typeof Highcharts === 'undefined') {
      return;
    }

    var selectedTime = getSelectedTime();
    if (selectedTime === 'day' || selectedTime === 'month') {
      hideFlowMeterBatteryUi();
      return;
    }

    var filterDate = getFilterDateFlowMeter(selectedTime);

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    var jqXHR = $.ajax({
      url: '/Station/GetChartDataBatteryFlowMeter',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
      },
    });
    g.register(jqXHR);

    jqXHR
      .done(function (response) {
        if (!g.isCurrent()) {
          return;
        }
        var res = response.data;
        if (res && res.voltageSeries && res.voltageSeries.length > 0) {
          renderChart(res.voltageSeries, res.capacitySeries);
        } else {
          $container.hide();
          $loading.hide();
          $empty.text('Data grafik baterai tidak tersedia.').show();
        }
      })
      .fail(function (_xhr, status) {
        if (status === 'abort') {
          return;
        }
        if (!g.isCurrent()) {
          return;
        }
        $container.hide();
        $loading.hide();
        $empty.text('Gagal memuat data.').show();
      })
      .always(function () {
        g.clearIfCurrent();
      });
  }

  $time.on('change', loadGrafikBattery);
  $periode.on('change changeDate', loadGrafikBattery);
  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    if ($(e.target).attr('href') === '#tab-data-telemetri') {
      loadGrafikBattery();
    }
  });
  loadGrafikBattery();
})(jQuery);
